import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import type { IProps } from './tasks-container';
import TasksHeader from './components/tasks-header';
import TasksContent from './components/tasks-content';
import { TaskStatusKey } from './utils/enums';
import { getInitialTaskStatus } from './utils/helper';
import hasPermission from '../../shared/utils/access-control/has-permission';
import { Permissions } from '../../shared/utils/access-control/enums/permissions';
import { redirectWithoutRefresh } from '../../shared/utils';
import { handleDemoAccountModuleViewed } from '../home/utils/helper';

const Tasks: React.FC<IProps> = ({ isMultichannelActive, resetTasksState }) => {
  const history = useHistory();
  const location = useLocation();

  const [taskStatus, setTaskStatus] = useState<TaskStatusKey>(
    getInitialTaskStatus(location?.search),
  );

  // Add state to track local task status counts
  const [localTaskStatusCount, setLocalTaskStatusCount] = useState(null);

  const onTaskStatusChange = (status) => {
    setTaskStatus(status);

    history.push(`?status=${status}`);
  };

  // Function to update local task status counts
  const updateLocalTaskStatusCounts = (newCounts) => {
    setLocalTaskStatusCount(newCounts);
  };

  // useEffect
  useEffect(() => {
    // Check Task Permission
    if (!isMultichannelActive || !hasPermission(Permissions.TASK_READ)) {
      redirectWithoutRefresh('/sequence');
    }

    // Update URL if no status parameter exists
    const searchParams = new URLSearchParams(location.search);
    const statusParam: string = searchParams.get('status');

    if (!statusParam) {
      // Only update URL if no status param exists
      history.push(`?status=${taskStatus}`);
    }

    handleDemoAccountModuleViewed('tasks');

    return () => {
      resetTasksState();
    };
  }, []);

  return (
    <div className="tasks">
      <TasksHeader
        taskStatus={taskStatus}
        onChange={(status: TaskStatusKey) => onTaskStatusChange(status)}
        localTaskStatusCount={localTaskStatusCount}
        updateLocalTaskStatusCounts={updateLocalTaskStatusCounts}
      />
      <TasksContent
        taskStatus={taskStatus}
        updateLocalTaskStatusCounts={updateLocalTaskStatusCounts}
      />
    </div>
  );
};

export default Tasks;
